import * as React from 'react'
import { CustomFormGroup } from '@components/controls/custom-form-group'
import { IconWithText } from '@components/icon-with-text'
import { USER_CHECK_MESSAGE } from '@modules/offers/common/details/personal-data/use-user-check'
import { ErrorMessage } from '@components/controls/form-error'
import { OfferDetailsPersonalDataAccountCreation } from '@modules/offers/common/details/personal-data/offer-details-personal-data-account-creation'
import { useSelector } from 'react-redux'
import { selectAppData } from '@store/slices/app-slice'
import { useApiRequest } from '@hooks/use-request'
import { commonObjectPost } from '@requests/basic-requests'
import { useFormContext, useWatch } from 'react-hook-form'
import { useNotification } from '@hooks/use-notification'

export const OfferDetailsPersonalDataNewClient = (): JSX.Element => {
  const { urls } = useSelector(selectAppData)
  const { notify } = useNotification()

  const { control, clearErrors } = useFormContext()

  const email = useWatch({ control, name: 'email' })

  const isInactiveErrorMessage = (message: string | undefined) => message === USER_CHECK_MESSAGE.EXISTING_INACTIVE_USER

  const { action: handleAccountActivation } = useApiRequest(async () => {
    await commonObjectPost(urls.account.reset_password_link, { email })
    clearErrors('email')
    notify({
      subtitle: 'Aktywacja konta',
      message: 'Sprawdź swoją skrzynkę pocztową i podążaj za przedstawionymi instrukcjami. ',
    })
  })

  return (
    <div className="col-md-7 col-12">
      <div className="border rounded bg-lighter-gray p-4 h-100 text-center text-md-start">
        <strong className="text-primary font-xxl">Uzupełnij swoje dane</strong>
        <p>Pozwoli to na zarządzanie kupowanym produktem</p>

        <div className="col-xl-8 col-12">
          <CustomFormGroup
            inputName="first_name"
            formControlProps={{ placeholder: 'np. Andrzej' }}
            label="Wpisz imię:"
            formLabelProps={{ className: 'font-md fw-semi-bold' }}
          />
          <CustomFormGroup
            inputName="last_name"
            formControlProps={{ placeholder: 'np. Nowak' }}
            label="Wpisz nazwisko:"
            formLabelProps={{ className: 'font-md fw-semi-bold' }}
          />
          <CustomFormGroup
            inputName="email"
            formControlProps={{ placeholder: 'email@nazwa.pl', type: 'email' }}
            label="Wpisz adres e-mail:"
            formLabelProps={{ className: 'font-md fw-semi-bold' }}
            renderError={({ message }) => (
              <div className="d-inline-block align-items-center mt-2">
                <ErrorMessage message={message ?? ''} flexClassName="d-inline" />
                {isInactiveErrorMessage(message) && (
                  <button
                    className="btn-unstyled fw-semi-bold font-sm mt-2 text-decoration-none text-primary"
                    onClick={handleAccountActivation}
                  >
                    , aktywuj swoje konto.
                  </button>
                )}
              </div>
            )}
          />

          <IconWithText
            text={
              <span className="font-xs">
                <strong>Pamiętaj!</strong> Sprawdź poprawność adresu e-mail, ponieważ wyślemy na nie potwierdzenie
                Twojego zakupu.
              </span>
            }
            iconClassName="uil-exclamation-circle text-primary font-xl me-2 align-self-start lh-initial"
            className="font-sm text-darker-gray px-0 mt-3"
          />
        </div>
        <hr className="mx-n4" />
        <OfferDetailsPersonalDataAccountCreation />
      </div>
    </div>
  )
}
